import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { Errors } from 'src/infrastructure/labels/errors';
import { Successes } from 'src/infrastructure/labels/successes';
import { UserDTO } from 'src/models/DTO/user/user';
import { ToastService } from 'src/services/core/toast/toast.service';
import { PayMethodsService } from 'src/services/request/pay-methods/pay-methods.service';
import { StripeService } from 'src/services/request/stripe/stripe.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

declare var Stripe: any;

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent extends HistoryBaseComponent implements OnInit {

  public cardholder: string = '';
  private _loggedUser?: UserDTO;

  constructor(
    private router: Router,
    private toastr: ToastService,
    private loggedUserService: LoggedUserService,
    private stripeService: StripeService,
    protected location: Location,
    protected historyService: HistoryService
  ) {
    super(location, historyService)
   }

  ngOnInit(): void {
    this.loggedUserService.userInfo$.subscribe((user) => {
      if (Object.keys(user).length) {
        this._loggedUser = user;
      }
    });

    const stripe = Stripe(Config.stripeKey);
    const elements = stripe.elements();
    const style = {
      base: {
        color: "#32325d",
        fontSize: "23px",
        fontWeight: "400",
        lineHeight: "23px",
        padding: "12px"
      }
    };

    const cardNumber = elements.create('cardNumber', { style: style, showIcon: true, placeholder: "Номер на карта" });
    const cardExpration = elements.create('cardExpiry', { style: style });
    const cardCVC = elements.create('cardCvc', { style: style });
    //const cardElement = elements.create('payment', { style: style, hidePostalCode: true, wallets: { applePay: 'never', googlePay: 'never' } });
    cardNumber.mount('#card-number');
    cardExpration.mount('#card-expiry');
    cardCVC.mount('#card-cvc');
    this.saveCard(stripe, elements, cardNumber)
  }

  setCardholder(event: any) {
    this.cardholder = event.target.value;
  }

  saveCard(stripe: any, elements: any, cardNumberElement: any) {
    const cardButton = document.getElementById('card-button');


    cardButton?.addEventListener('click', async (ev) => {
      if (!this.cardholder) {
        this.toastr.error(Errors.bg.cardHolderIsInvalid)
        return;
      }
      const {paymentMethod, error} = await stripe.createPaymentMethod({
          type: 'card',
          card: cardNumberElement,
          billing_details: {
            name: this.cardholder
          }
        }
      );

      if (error) {
        // Display error.message in your UI.
        this.toastr.error(error.message);
      } else {
        // You have successfully created a new PaymentMethod
        this.stripeService.attachPaymentMethod(paymentMethod.id, this._loggedUser!.data.payment_accounts[0].provider_account_id).subscribe(() => {
          this.toastr.success(Successes.bg.addCard);
          this.router.navigate(['payments/card/select']);

        },
        (error) => {
          this.toastr.error(error.error.error.message);
        })
        // CREATE ROUTE FOR PAYMENT SERVICE
      }
    });
  }

}
